<template>
    <div class="plato-viewer">
        <div class="plato-viewer-selector p-2">
            <div class="row no-gutters align-items-center">
                <div class="col">
                    <div class="d-block d-md-none">
                        <select class="custom-select" v-model="currentLayer">
                            <template v-for="layer in selectorLayers">
                                <option :value="layer.id">
                                    {{ layer.label }}
                                </option>
                            </template>
                        </select>
                    </div>
                    <div class="d-none d-md-block">
                        <div class="row">
                            <template v-for="layer in selectorLayers">
                                <div class="col">
                                    <div class="plato-viewer-checkbox custom-control custom-checkbox"
                                        :class="`plato-viewer-checkbox--${layer.key}`"
                                        :key="layer.id">
                                        <input
                                            type="checkbox"
                                            class="custom-control-input"
                                            :checked="isChecked(layer)"
                                            :id="checkboxId(layer)"
                                            @change="handleCheckboxChanged(layer, $event)"
                                        >
                                        <label class="plato-viewer-checkbox-label custom-control-label" :for="checkboxId(layer)">
                                            {{ layer.label }}
                                        </label>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
                <div class="col-auto">
                    <button class="btn text-primary p-0 plato-viewer-zoom-button ml-2" @click="handleZoomButtonClicked">
                        <svg width="35" height="35">
                            <use xlink:href="#sprite-zoom" href="#sprite-zoom"></use>
                        </svg>
                    </button>
                </div>
            </div>
        </div>

        <div class="plato-map-responsive">
            <PlatoMap :current="currentLayer" :layers="layers" disabled />
        </div>

        <b-modal
            size="xl"
            hide-header
            hide-footer
            centered
            body-class="plato-viewer p-0"
            @shown="handleModalShown"
            @hidden="handleModalHidden"
            ref="modal"
        >
            <button class="btn p-3 plato-viewer-modal-close" @click="handleCloseModalButtonClicked">
                <svg width="20" height="20">
                    <use xlink:href="#sprite-close" href="#sprite-close"></use>
                </svg>
            </button>
            <template v-if="modalMapVisible">
                <div class="plato-map-responsive plato-map-responsive--modal">
                    <PlatoMap :current="currentLayer" :layers="layers" />
                </div>
            </template>
        </b-modal>
    </div>
</template>

<script>
    import { BModal } from 'bootstrap-vue';
    import layer1 from './svgs/plato-layer-1.svg';
    import layer2 from './svgs/plato-layer-2.svg';
    import layer3 from './svgs/plato-layer-3.svg';
    import layer4 from './svgs/plato-layer-4.svg';
    import layer5 from './svgs/plato-layer-5.svg';

    export default {
        components: {
            PlatoMap: () => import(/* webpackChunkName: 'plato-map' */'./PlatoMap.vue'),
            BModal,
        },
        props: {
            platoLabel: {
                type: String,
                default: 'réseau PLATO',
            },
            citiesLabel: {
                type: String,
                default: 'administratif',
            },
            routesLabel: {
                type: String,
                default: 'axes de communication',
            },
            terrainLabel: {
                type: String,
                default: 'paysages et reliefs',
            },
            regionLabel: {
                type: String,
                default: 'Grand Est'
            },
        },
        data() {
            return {
                currentLayer: 5,
                modalMapVisible: false,
            }
        },
        computed: {
            layers() {
                return [
                    { id: 1, url: layer1, label:this.regionLabel, key:'region' },
                    { id: 2, url: layer2, label:this.terrainLabel, key:'terrain' },
                    { id: 3, url: layer3, label:this.routesLabel, key:'routes' },
                    { id: 4, url: layer4, label:this.citiesLabel, key:'cities' },
                    { id: 5, url: layer5, label:this.platoLabel, key:'plato' },
                ]
            },
            selectorLayers() {
                return [...this.layers].reverse();
            },
        },
        methods: {
            isChecked(layer) {
                return layer.id <= this.currentLayer;
            },
            handleCheckboxChanged(layer, e) {
                if(layer.id === 1) {
                    e.target.checked = true;
                }
                this.currentLayer = e.target.checked ? layer.id : layer.id - 1;
            },
            handleZoomButtonClicked() {
                this.$refs.modal.show();
            },
            handleCloseModalButtonClicked() {
                this.$refs.modal.hide();
            },
            handleModalShown() {
                // display the map only when the modal is fully shown to have the tight size
                this.modalMapVisible = true;
            },
            handleModalHidden() {
                this.modalMapVisible = false;
            },
            checkboxId(layer) {
                return `plato-map-layer-${layer.id}`;
            },
        },
    }
</script>